/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdGroupTargetingResponseDto } from "./AdGroupTargetingResponseDto";
export type AdGroupDto = {
  /**
   * 광고그룹 ID
   */
  id: string;
  /**
   * 캠페인 ID
   */
  campaignId: string;
  /**
   * 캠페인명
   */
  campaignName: string;
  /**
   * 캠페인 상태
   */
  campaignStatus: AdGroupDto.campaignStatus;
  /**
   * 광고주 ID
   */
  advertiserId: string;
  /**
   * 광고주 회사명
   */
  advertiserName: string;
  /**
   * 광고그룹명
   */
  name: string;
  /**
   * 광고 타입
   */
  adType: AdGroupDto.adType;
  /**
   * 과금 유형 (adType에서 자동 파생)
   */
  billingType: AdGroupDto.billingType;
  /**
   * 단가
   */
  unitPrice: number;
  /**
   * 타겟팅 설정
   */
  targeting?: AdGroupTargetingResponseDto;
  /**
   * 상태
   */
  status: AdGroupDto.status;
  /**
   * 삭제 여부
   */
  isDeleted: boolean;
  /**
   * 삭제일
   */
  deletedAt?: string;
  /**
   * 생성일
   */
  createdAt: string;
  /**
   * 수정일
   */
  updatedAt: string;
};
export namespace AdGroupDto {
  /**
   * 캠페인 상태
   */
  export enum campaignStatus {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
  /**
   * 광고 타입
   */
  export enum adType {
    HALF_VIEW_CPE = "HALF_VIEW_CPE",
    HALF_VIEW_CPM = "HALF_VIEW_CPM",
    LIGHT_VIEW_CPE = "LIGHT_VIEW_CPE",
    LIGHT_VIEW_CPM = "LIGHT_VIEW_CPM",
    CPQ = "CPQ",
    TOP_BANNER = "TOP_BANNER",
    EXCHANGE = "EXCHANGE",
    QUIZ_CREATION = "QUIZ_CREATION",
  }
  /**
   * 과금 유형 (adType에서 자동 파생)
   */
  export enum billingType {
    CPM = "CPM",
    CPC = "CPC",
    CPE = "CPE",
    CPQ = "CPQ",
  }
  /**
   * 상태
   */
  export enum status {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
}
